module.exports = __webpack_public_path__ + "static/media/logoHeader.dd011b4a.png";